import { getMe, getPlots } from "../net/api";
import { loadCompass } from "./compass";
import { loadMailSummary } from "./mail";
import { loadAllMarkers } from "./markers";
import { loadSettings } from "./settings";
import { $plots, $session, toast } from "./stores";
import { refreshMyAssets } from "./myAssets";

/**
 * Welcome: the estate may have been assigned before this connection subscribed, so re-read (spec 2d Review Focus 1).
 * Only claims "no free lot" when both reads succeeded; on any failure the stores and toast are left alone.
 */
export async function onWelcome(): Promise<void> {
  void loadCompass(); // independent of the reads below: its failure only disables compass editing
  void loadSettings(); // independent too: its failure only disables editing and leaves the default camera
  let plots, me;
  try {
    [plots, me] = await Promise.all([getPlots(), getMe()]);
  } catch {
    return;
  }
  $plots.set(plots);
  $session.set(me);
  void loadAllMarkers();
  if (me.kind !== "agent") void loadMailSummary();
  // AssetsChanged sent while this connection was down is lost: re-read so the shelf is current (spec 2o §3.6)
  if (me.kind !== "agent") refreshMyAssets().catch(() => {});
  if (me.kind !== "agent" && !plots.some((p) => p.kind === "estate" && p.owner_id === me.id)) {
    toast("目前沒有空地", 6000);
  }
}
